export interface EmaPoint {
  time: number;
  value: number;
}

export function ema(closes: readonly number[], length: number): (number | null)[] {
  const out: (number | null)[] = [];
  if (length < 1) return closes.map(() => null);
  const k = 2 / (length + 1);
  let seed = 0;
  let prev: number | null = null;
  for (let i = 0; i < closes.length; i += 1) {
    const close = closes[i];
    if (prev === null) {
      seed += close;
      if (i + 1 < length) {
        out.push(null);
        continue;
      }
      prev = seed / length;
      out.push(prev);
      continue;
    }
    prev = close * k + prev * (1 - k);
    out.push(prev);
  }
  return out;
}

export function emaOnBuckets(
  minutes: readonly { time: number; close: number }[],
  bucketOf: (ms: number) => number | null,
  length: number,
): EmaPoint[] {
  const buckets: { time: number; close: number }[] = [];
  for (const bar of minutes) {
    const start = bucketOf(bar.time);
    if (start === null) continue;
    const last = buckets[buckets.length - 1];
    if (last && last.time === start) last.close = bar.close;
    else buckets.push({ time: start, close: bar.close });
  }
  const values = ema(buckets.map((bar) => bar.close), length);
  const out: EmaPoint[] = [];
  for (let i = 0; i < buckets.length; i += 1) {
    const value = values[i];
    if (value !== null) out.push({ time: buckets[i].time, value });
  }
  return out;
}

/** Latest point whose time is at or before each chart time. */
export function projectStep(
  points: readonly EmaPoint[],
  chartTimes: readonly number[],
): (number | null)[] {
  const out: (number | null)[] = [];
  let index = 0;
  let current: number | null = null;
  for (const time of chartTimes) {
    while (index < points.length && points[index].time <= time) {
      current = points[index].value;
      index += 1;
    }
    out.push(current);
  }
  return out;
}
